(()=>{
 const menus=[...document.querySelectorAll('.fx-nav-dropdown,.fx-mobile-menu')];
 menus.forEach(menu=>{
  menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false;});});
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
  menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;}));
 });
 document.addEventListener('click',event=>menus.forEach(menu=>{if(!menu.contains(event.target))menu.open=false;}));
 const toc=document.querySelector('[data-fx-toc]');
 if(toc){
  const headings=[...document.querySelectorAll('.fx-editorial-body>h2')];
  if(headings.length>2){
   const nav=toc.querySelector('nav');
   headings.forEach((heading,index)=>{if(!heading.id)heading.id=`fx-topic-${index+1}`;const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;nav.append(link);});
   toc.hidden=false;
  }
 }
})();
